<div class="ConfirmMessageModal">
    <mat-toolbar color="warn">
        <h3>{{confirmTitle}} </h3>
    </mat-toolbar>
        <mat-dialog-content>
            <h5 fxLayout="row" fxLayoutAlign="center center" class="text-center" class="mt-15">{{confirmDescription}}</h5>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-dialog-close mat-button color="secondary">{{ "cancel" | translate }}</button>
            <button id="ConfirmModal__submitButton" [mat-dialog-close]="'true'" mat-button color="warn" cdkFocusInitial>{{ "confirm" | translate }}</button>
        </mat-dialog-actions>
  </div>